import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      '& $calendarIcon': {
        visibility: 'visible',
        opacity: 1,
      },
    },
    '& $calendarIcon': {
      visibility: 'hidden',
      opacity: 0,
      transition: 'visibility 0s, opacity 0.5s ease-in',
    },
  },
  card: ({ isDragging, isCompleted }) => ({
    flexShrink: 0,
    cursor: 'pointer',
    padding: theme.spacing(1.5),
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    backgroundColor: '#f4f5f7',
    border: isDragging ? '20px solid #d8dde1' : '1px solid transparent',
    opacity: isDragging ? 0.25 : isCompleted ? 0.5 : 1,
    transform: isDragging ? 'scale(0.95)' : 'scale(1)',
    boxShadow: isDragging ? 'none' : undefined,
    transition: 'all 0.3s ease',
    '&:hover': {
      border: '1px solid #d8dde1',
      opacity: 1,
    },
    '&:active': {
      animation: 'clickAnimation 0.3s ease-in-out',
    },
    '&:has(button:active)': {
      animation: 'none',
    },
  }),
  taskContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  taskName: {
    textIndent: '20px',
    fontSize: '13.5px',
  },
  outlinedTick: {
    flexShrink: 0,
    width: '17px',
    borderRadius: '50%',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '20px',
    '&:hover': {
      color: theme.palette.success.dark,
    },
  },
  solidTick: {
    flexShrink: 0,
    width: '17px',
    borderRadius: '50%',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '20px',
    color: theme.palette.success.xDark,
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  avatar: {
    width: '20px',
    height: '20px',
    fontSize: 'x-small',
  },
  deadlineBtn: {
    fontSize: '11px',
  },
  calendarIcon: {
    width: '20px',
    height: '20px',
  },
  actionIcons: {
    width: '20px',
    height: '20px',
  },
  customTableCell: {
    paddingLeft: '0px !important',
    width: 'fit-content !important',
  },
}));
